import React, { useEffect, useState } from 'react';
import { Button, FormControl, InputLabel, MenuItem, OutlinedInput } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import nest from '../../../services/nest';
import { getEmailLogin } from '../../../services/auth';
import Select from '@mui/material/Select';
import Loading from '../../../components/Loading';



function ModalNewUser({mostrar, handleClose, loadOutrosUsuariosAbaixo, setIdUsuarioDependente, setAlerta, setModalEditarUsuarioVisible}) {
    let initialized = false;
    const [itemsCargo, setItemsCargo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemsSetor, setItemsSetor] = useState([]);
    const [form, setForm] = useState({
        nome: '',
        email: '',
        senha: '',
        CargoValue: '',
        SetorValue: ''
    });
   
    const fetchData = async () => {
        Promise.all([
            nest.get("/cliente/cliente-usuario-setores")
            .then((response) => {
                setItemsSetor(response.data);
            }),
            nest.get("/cliente/cliente-usuario-cargos")
            .then((response) => {
                setItemsCargo(response.data);
            })
        ]);

    };
    useEffect(() => {
        if (!initialized) {
            fetchData();
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initialized = true;
        }
    }, []);
    useEffect(() => {
        if(!mostrar){
            setForm({
                nome: '',
                email: '',
                senha: '',
                CargoValue: '',
                SetorValue: ''
            })
        }
    }, [mostrar])
    const cadastrarUsuario = async () => {
        if(!form.nome){
            setAlerta({
                status: true,
                msg: 'Preencha o nome!',
                type: 'error'
            })
            return false;
        }
        if(!form.email){
            setAlerta({
                status: true,
                msg: 'Preencha o e-mail!',
                type: 'error'
            })
            return false;
        }
        if(!handleValidEmail()){
            setAlerta({
                status: true,
                msg: 'O e-mail não é valido!',
                type: 'error'
            })
            return false;
        }
        if(!form.senha){
            setAlerta({
                status: true,
                msg: 'Preencha a senha!',
                type: 'error'
            })
            return false;
        }
        if(!form.CargoValue){
            setAlerta({
                status: true,
                msg: 'Selecione o cargo!',
                type: 'error'
            })
            return false;
        }
        if(!form.SetorValue){
            setAlerta({
                status: true,
                msg: 'Selecione o setor!',
                type: 'error'
            })
            return false;
        }

        let clienteUsuarioId = await getEmailLogin();
        setLoading(true);
        const data = {
        email: form.email,
        senha: form.senha,
        nome: form.nome,
        cargo_id: form.CargoValue,
        setor_id: form.SetorValue,
        status: 1,
        conta_master_id: clienteUsuarioId,
        };
        nest.post("/cliente/cliente-usuarios/criarUsuario",
            data
        ).then(function (response) {
            const resposta = response.data;
            loadOutrosUsuariosAbaixo();
            setIdUsuarioDependente(resposta);
            setModalEditarUsuarioVisible(true)
            setLoading(false);
            handleClose();
        }).catch(function (error) {
            console.log(error);
            if(error?.response?.data?.message){
                setAlerta({
                    status: true,
                    msg: error?.response?.data?.message,
                    type: 'error'
                })
            }
            setLoading(false);
        });
       
    }
    const handleValidEmail = () => {
        setForm({ ...form, email: form.email.trim() })
        let reg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        if (form.email !== '' && form.email != null) {
        if (reg.test(form.email) === false) {
            setAlerta({
                status: true,
                msg: 'O e-mail não é valido!',
                type: 'error'
            })
            return false
        } else if (reg.test(form.email) === true) {
            return true
        }
        }
    }
    return (
        <Modal show={mostrar} onHide={handleClose} centered>
            <Loading open={loading} />
            <Modal.Header closeButton style={{paddingTop: 10, paddingBottom: 10}}>
                <Modal.Title style={{
                    color: "var(--main-bg-color)", 
                    width: "100%", 
                    textAlign: 'center',
                }}>Cadastrar usuário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{marginLeft: 50,marginRight: 50, marginTop: 0}}>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel>Nome</InputLabel>
                    <OutlinedInput
                      type="text"
                      value={form.nome}
                      onChange={(e) => setForm({ ...form, nome: e.target.value })}
                      label="Nome"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel>E-mail</InputLabel>
                    <OutlinedInput
                      label="E-mail"
                      value={form.email}
                      type="email"
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      onBlur={() => handleValidEmail()}
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel>Senha</InputLabel>
                    <OutlinedInput
                      type="text"
                      value={form.senha}
                      onChange={(e) => setForm({ ...form, senha: e.target.value })}
                      label="Senha"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel id="turno">Cargo</InputLabel>
                    <Select
                    labelId="turno"
                    value={form.CargoValue}
                    label="Cargo"
                    onChange={(e) => setForm({ ...form, CargoValue: e.target.value })}
                    >
                    <MenuItem disabled value=""><em>Selecione um cargo</em></MenuItem>
                    {itemsCargo.length > 0 && (
                        itemsCargo.map((element, index) => (
                            <MenuItem key={index} value={element.id}>{element.nome}</MenuItem>
                        ))
                    )}
                    </Select>
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel id="turno">Setor</InputLabel>
                    <Select
                    labelId="turno"
                    value={form.SetorValue}
                    label="Setor"
                    onChange={(e) => setForm({ ...form, SetorValue: e.target.value })}
                    >
                    <MenuItem disabled value=""><em>Selecione um setor</em></MenuItem>
                    {itemsSetor.length > 0 && (
                        itemsSetor.map((element, index) => (
                            <MenuItem key={index} value={element.id}>{element.nome}</MenuItem>
                        ))
                    )}
                    </Select>
                </FormControl>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <div  onClick={() => handleClose()}>
                    <Button style={{backgroundColor: "#a3a3a3"}} variant="contained">
                       Cancelar
                    </Button>
                </div>
                <div  onClick={() => cadastrarUsuario()}>
                    <Button style={{backgroundColor: "var(--main-bg-color)"}} variant="contained" disabled={loading}>
                       Cadastrar
                    </Button>
                </div>
            </Modal.Footer>
            
        </Modal>
    );
}

export default ModalNewUser;